export default __webpack_public_path__ + "static/media/head-bg.84ad74a4.png";